var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecycleActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16433_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 21.75L12 19.5L14.25 17.25",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2466 7.04906L17.4225 10.1231L14.3494 9.29906",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4025 13.1972L6.5775 10.125L3.50531 10.9472",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57749 10.125L2.45249 17.25C2.3209 17.4779 2.25159 17.7364 2.25153 17.9996C2.25146 18.2628 2.32063 18.5214 2.4521 18.7493C2.58357 18.9773 2.77271 19.1667 3.00053 19.2985C3.22834 19.4302 3.48681 19.4997 3.74999 19.5H8.24999",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5H20.25C20.5132 19.4997 20.7716 19.4302 20.9995 19.2985C21.2273 19.1667 21.4164 18.9773 21.5479 18.7493C21.6794 18.5214 21.7485 18.2628 21.7485 17.9996C21.7484 17.7364 21.6791 17.4779 21.5475 17.25L19.3781 13.5",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4225 10.125L13.2975 3C13.1658 2.77225 12.9764 2.58316 12.7485 2.4517C12.5206 2.32024 12.2622 2.25104 11.9991 2.25104C11.736 2.25104 11.4775 2.32024 11.2496 2.4517C11.0217 2.58316 10.8324 2.77225 10.7006 3L8.53125 6.75",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16433_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleActive);
export default __webpack_public_path__ + "static/media/recycle_active.581ef34da8667c0ce9dc9d30d807e0a0.svg";
export { ForwardRef as ReactComponent };